import { isEmpty } from "lodash";
import React, { useState } from "react";
import Select from "react-dropdown";
import { useFormik } from "formik";
import { addCuisineSchema } from "../../../validations/cuisineValidations";
import {
	useAddFoodsCuisine,
	useUpdateFoodCuisine,
} from "../../../queryHooks/useCuisine";
import CS from "../../../services/commonService";
import { useEffect } from "react";
import { useStore } from "../../../zustand/store";

//  Component starts
const AddUpdate = ({ cuisine, onCloseModal, getCuisines }) => {
	//	Pre-defined values
	if (isEmpty(cuisine)) cuisine = { cuisineName: "" };
	const statusOptions = [
		{ value: true, label: "Active" },
		{ value: false, label: "Inactive" },
	];
	const setLoading = useStore((state) => state.setLoading);
	const [status, setStatus] = useState(
		statusOptions.find((option) => option.value === cuisine.status) || {
			value: true,
			label: "Active",
		}
	);

	/******************************************************************************************
    @Purpose    :   To add-update cuisine
    *******************************************************************************************/
	const [formData] = useState({
		name: cuisine.name,
		is_featured: status.is_active,
	});

	const { values, errors, handleChange, handleSubmit, touched } = useFormik({
		initialValues: formData,
		validationSchema: addCuisineSchema,
		onSubmit: (value) => {
			if (cuisine.cuisine_id) {
				const body = {
					name: value.name?.trim(),
					is_active: status.value == 1 ? true : false,
				};
				const obj = {
					body: body,
					id: cuisine.cuisine_id,
				};
				setLoading(true);
				updateCuisine(obj);
			} else {
				const body = {
					name: value.name?.trim(),
					is_active: status.value == 1 ? true : false,
				};
				setLoading(true);
				addCuisine(body);
			}
		},
	});

	const {
		mutateAsync: addCuisine,
		error: erroraddCuisine,
		data: dataAddCuisine,
	} = useAddFoodsCuisine();

	useEffect(() => {
		if (dataAddCuisine) {
			setLoading(false);
			if (dataAddCuisine.status === "success") {
				onCloseModal();
				getCuisines();
				CS.showSuccessMessage(dataAddCuisine.message);
			} else if (dataAddCuisine.status === "fail") {
				CS.showErrorMessage(dataAddCuisine.message);
			}
		}
	}, [dataAddCuisine]);

	useEffect(() => {
		if (erroraddCuisine) {
			setLoading(false);
			CS.showErrorMessage(erroraddCuisine.response?.data?.message);
		}
	}, [erroraddCuisine]);

	/******************************************************************************************
    @Purpose    :   Update cuisine
    *******************************************************************************************/

	const {
		mutateAsync: updateCuisine,
		error: errorUpdateCuisine,
		data: dataUpdateCuisine,
	} = useUpdateFoodCuisine();

	useEffect(() => {
		if (dataUpdateCuisine) {
			setLoading(false);
			if (dataUpdateCuisine.status === "success") {
				onCloseModal();
				getCuisines();
				CS.showSuccessMessage(dataUpdateCuisine.message);
			} else if (dataUpdateCuisine.status === "fail") {
				CS.showErrorMessage(dataUpdateCuisine.message);
			}
		}
	}, [dataUpdateCuisine]);

	useEffect(() => {
		if (errorUpdateCuisine) {
			setLoading(false);
			CS.showErrorMessage(errorUpdateCuisine.response?.data?.message);
		}
	}, [errorUpdateCuisine]);

	return (
		<div className="modal-content">
			<div className="modal-header">
				<h5 className="modal-title">
					{" "}
					{cuisine.cuisine_id ? "Update Cuisine" : "Add Cuisine"}
				</h5>
			</div>
			<div className="notification-form modal-body card profile-card brand-modal">
				<div className="row">
					<div className="col-md-12">
						<form onSubmit={(event) => handleSubmit(event)}>
							<div className="mb-md-4 mb-3">
								<div className="form-group mb-0">
									<label className="label xl-label">
										Cuisine Name<sup className="text-danger">*</sup>
									</label>
									<div className="w-100 position-relative">
										<input
											className="form-control"
											type="text"
											id="name"
											name="name"
											placeholder="Enter a Cuisine name"
											value={values.name}
											onChange={handleChange}
										/>
										<div className="error-message-password">
											<span className="text-danger error-msg d-block mb-2">
												{errors.name && touched.name ? errors.name : null}
											</span>
										</div>
									</div>
								</div>
							</div>
							{cuisine.cuisine_id && (
								<div className="mb-md-4 mb-3">
									<div className="form-group mb-0">
										<label className="label xl-label">
											Status<sup className="text-danger">*</sup>
										</label>
										<div className="w-100 position-relative">
											<Select
												value={status}
												onChange={(option) => setStatus(option)}
												options={statusOptions}
											/>
										</div>
									</div>
								</div>
							)}
							<div className="mt-5 text-right">
								<button className="btn btn-primary" type="submit">
									{cuisine.cuisine_id ? "Update" : "Add"}
								</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
	);
};

export default AddUpdate;
